// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__ZlkEN","col":"styles_col__nTCZN"};